import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import { useMemo, useState } from 'react';
import { useMobile } from './useMobile';

export type UseTournamentButtonGroupParams = Pick<
  Tournament,
  'phase' | 'bracketType'
>;
export type TournamentButton =
  | 'BRACKET'
  | 'REGISTRATION'
  | 'PARTICIPANTS'
  | 'HEATS';

export function useTournamentButtonGroup({
  phase,
  bracketType,
}: UseTournamentButtonGroupParams) {
  const activeTabDefault =
    phase === 'registration' || phase === 'checkIn'
      ? 'REGISTRATION'
      : bracketType === 'heats'
      ? 'HEATS'
      : bracketType === 'no-bracket'
      ? 'PARTICIPANTS'
      : 'BRACKET';

  const buttonValues =
    bracketType === 'no-bracket'
      ? ['REGISTRATION', 'PARTICIPANTS']
      : [
          'REGISTRATION',
          'PARTICIPANTS',
          bracketType === 'heats' ? 'HEATS' : 'BRACKET',
        ];
  const [activeTab, setActiveTab] =
    useState<TournamentButton>(activeTabDefault);

  const isMobile = useMobile();
  const buttonWidth = isMobile ? '164px' : '304px';

  const TournamentButtonGroup = useMemo(() => {
    return (
      <ToggleButtonGroup
        value={activeTab}
        exclusive
        onChange={(_, value) => {
          if (value) {
            setActiveTab(value);
          }
        }}
        size="small"
        sx={{ width: '100%', maxWidth: `calc(3 * ${buttonWidth})`, mt: 4 }}
      >
        <ToggleButton
          value="REGISTRATION"
          sx={{
            width: buttonWidth,
          }}
        >
          REGISTRATION
        </ToggleButton>
        <ToggleButton
          value="PARTICIPANTS"
          sx={{
            width: buttonWidth,
          }}
        >
          PARTICIPANTS
        </ToggleButton>
        <ToggleButton
          value={bracketType === 'heats' ? 'HEATS' : 'BRACKET'}
          sx={{
            width: buttonWidth,
          }}
          disabled={
            phase === 'registration' ||
            phase === 'checkIn' ||
            bracketType === 'no-bracket'
          }
        >
          {bracketType === 'heats' ? 'HEATS' : 'BRACKETS'}
        </ToggleButton>
      </ToggleButtonGroup>
    );
  }, [activeTab, phase, bracketType, buttonWidth]);
  return { activeTab, setActiveTab, TournamentButtonGroup };
}
